import Vue from 'vue';
import store from "src/store/index";

Vue.filter("workAge", function(value) {   //根据入职日期计算工作年限
    if(value == undefined){
        return "";
    }
    var arr=[];
    arr[0]=value.split(" ")[0].split("-")[0];
    arr[1]=value.split(" ")[0].split("-")[1];
    arr[2]=value.split(" ")[0].split("-")[2];
    var now=new Date();
    var year=now.getFullYear();
    var mouth=now.getMonth()+1;
    var day=now.getDate();
    var age=parseInt((year*365+mouth*30+day-arr[0]*365-arr[1]*30-arr[2])/365);
    return age;
});

Vue.filter('cycleStr',function(cycle){  //返回周期拼接结果
    if(cycle == undefined){
        return '';
    }
    return cycle.cycle_year?`${cycle.cycle_year}#${cycle.cycle_number}`:"";
});

Vue.filter("menuIcon",function(picName,active){  //菜单icon 切换
    let arr = picName.split(".");
    let name = arr[0];
    let suffix = arr[1];
    picName = active?`${name}-active.${suffix}`:picName;
    return `../../../static/img/${picName}`;
});

Vue.filter("ticketTar", function(target) {   //罚单适用对象
    switch (target) {
        case 10:
            return "BU"
        case 20:
            return "合伙人"
        case 30:
            return "职员"
    }
});

Vue.filter("justDate", function(date) {   //时间str仅有日期
    date = date || "";
    return date.split(" ")[0];
});

Vue.filter("placeholder", function(val) {   //时间str仅有日期
    if(val === undefined || val === null){
        val = "";
    }
    return String(val).trim() || "————"
});

Vue.filter("titleLimit", function(str="") {   //BU名称 或者 头部显示字数限制
    let num = 20;
    if(str.length > 20){
        str = str.substr(0,17)+'...';
    }
    return str;
});


// ****特定页面相关
// Vue.filter("commentTime", function(str) {   //任务remark 评论时间
//     if(!str){
//         return "";
//     }
//     let time_arr = str.split(" ");
//     return `${time_arr[0]} ${time_arr[1].substr(0, 5)}`
// });

Vue.filter("applyStatus", function(status) {   //审核页面 返回对应状态str
    return status==1?"处理":"详情";
});

Vue.filter('bonus',function(obj){  //结算单 返回结算单合计的钱
    let val = obj ? obj.confirm_money : 0;
    let num = parseFloat(val);
    // return num>0?num+'元':'0元';
    return `${num}元`
});

Vue.filter('ticket_curr',function(obj){  //结算单 返回结算单合计的钱
    if(obj.detail_type == 20){
        return `-${obj.trans_number}元`;
    }
    return `${obj.trans_number}元`;
});



Vue.filter("ticket",function(amount,name){  //后台罚单列表页 罚款文本
    switch (name) {
        case "任务延期":
            return `平均任务金额/天`;
        case "任务超期":
            return `2倍平均任务金额/天`;
        case "任务滞留":
            return `${amount}%对应任务金额/天`;
        default:
            return `${amount}${store.getters.ticket_curr.currency_name || '罚币'}`;
    }
});

Vue.filter("cycleTip",function(start,type){  //后台周期间隔设置 提示文本
    if(!start || !type){
        return "";
    }
    let interval = 1;  //间隔月份
    switch (type){
        case 10:
            interval = 1;
            break;
        case 20:
            interval = 3;
            break;
        case 30:
            interval = 6;
            break;
        case 40:
            interval = 12;
            break;
    }
    let arr = [];
    let month = start;
    do{
        month+=interval;
        if(month>12){
            month = month - 12;
        }
        arr.push(month);
    }while(month != start)
    let str = arr.sort((a,b)=>{
        return a-b;
    }).map(val=>val+"月").join('、');
    return `周期将于${str}开启`
});

// Vue.filter("CycleTypeText",function(type){  //后台罚单列表页 罚款文本
//     const strObj = {
//         10: "每月",
//         20: "每季度", 
//         30: "半年", 
//         40: "每年",
//     }
//     return strObj[type];
// });





// WEBPACK FOOTER //
// ./src/config/filter-config.js